import styled from 'styled-components'

import { theme } from 'styles/theme'

const { space, colors, radii, borderWidths, fontSizes } = theme

export const FormWrapper = styled.div`
  background-color: ${colors['neutral-background-default']};

  button {
    width: 100%;
  }
`

export const FormHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${space['spacing-md']};
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-md']};

  .inputs-wrapper {
    display: flex;
    flex-direction: column;
    gap: ${space['spacing-sm']};
  }

  p > a {
    font-size: ${fontSizes['font-size-caption']};
  }
`

export const AssinaturaConjuntaFieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
  border: none;
  margin: 0;
  padding: 0;

  legend {
    padding: 0;
  }
`

export const SelectorGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${space['spacing-sm']};

  & > * {
    flex: 1;
  }
`

export const RepresentativeSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
`

export const CnaeInfoBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: ${space['spacing-sm']};
  gap: ${space['spacing-sm']};
  background-color: ${colors['primary-background-default']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['primary-border-default']};
  border-radius: ${radii['corner-radius-sm']};
`

export const CNAETextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxs']};
`

export const SubmitErrorBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: ${space['spacing-sm']};
  gap: ${space['spacing-sm']};
  background-color: ${colors['danger-background-default']};
  border: ${borderWidths['border-stroke-micro']} solid ${colors['danger-border-default']};
  border-radius: ${radii['corner-radius-sm']};
`
